import React from 'react';
import toast from 'react-hot-toast';
import { on } from 'stream';

interface RefundConfirmationPromptProps {
    onRefund:  any;
  onClose?: () => void;
  showRefundPrompt: boolean;
}

const RefundConfirmationPrompt: React.FC<RefundConfirmationPromptProps> = ({ onRefund, onClose,  }) => {

  const handleRefundInvoice = async (e: React.MouseEvent<HTMLButtonElement>) => {
    onRefund(e);
    onClose && onClose();
    toast.success('Invoice refunded successfully!');
  };

  const handleKeepInvoice = () => {
    onClose && onClose();
  };

return (
  <>
    <div className="h-screen">
      <div className="  flex justify-center mt-[13px] ">
        <h1>
        You are about to request for a refund for this invoice ? 
        </h1>
      </div>
      <div role="form" onSubmit={(e) => e.preventDefault()}>
        <div className="flex ml-[10px] pt-[79px] pb-[40px]">
          <button
            className="w-[239px] rounded-[4px] h-[55px] bg-[#FB0303] text-white font-semibold"
            onClick={handleRefundInvoice}
          >
           Yes Refund
          </button>
        </div>
        <div className="flex ml-[10px] pb-[60px]">
          <button
            className="w-[239px] rounded-[4px] h-[55px] bg-[#FFFFFF] text-[#044E97] font-semibold border border-blue-500"
            onClick={handleKeepInvoice}
          >
          Go back to Invoice
          </button>
        </div>
      </div>
    </div>
  </>
);
};

export {RefundConfirmationPrompt};
